// {
//     "total_owned_units": 5,
//     "blocked_open_units": 5,
//     "blocked_partial_units": 0,
//     "total_blocked_units": 5,
//     "sellable_units": 0,
//     "managed_units": 0,
//     "message": "Your total sellable units are 0."
// }

interface IMarketSellerUnits {
  total_owned_units: number;
  blocked_open_units: number;
  blocked_partial_units: number;
  total_blocked_units: number;
  sellable_units: number;
  managed_units: number;
  message: string;
}

class MarketSellerPropertyUnits implements IMarketSellerUnits {
  total_owned_units: number;
  blocked_open_units: number;
  blocked_partial_units: number;
  total_blocked_units: number;
  sellable_units: number;
  managed_units: number;
  message: string;

  constructor(data: Partial<IMarketSellerUnits>) {
    this.total_owned_units = data?.total_owned_units ?? 0;
    this.blocked_open_units = data?.blocked_open_units ?? 0;
    this.blocked_partial_units = data?.blocked_partial_units ?? 0;
    this.total_blocked_units = data?.total_blocked_units ?? 0;
    this.sellable_units = data?.sellable_units ?? 0;
    this.managed_units = data?.managed_units ?? 0;
    this.message = data?.message ?? '';
  }

  static fromJson(json: any) {
    return new MarketSellerPropertyUnits(json);
  }
}

export default MarketSellerPropertyUnits;
